module.exports = __webpack_public_path__ + "img/gdco-login.3aa99cae.svg";